export default __webpack_public_path__ + "./images/pf.14e35c00.png";